"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditOrders = void 0;
const button_1 = require("client/components/material/button");
const claims_list_1 = require("client/modules/orders/modules/orders-list/components/claims-list");
const store_1 = require("client/modules/orders/store");
const store_2 = require("client/modules/users/store");
const Add_1 = require("material-ui-icons/Add");
const Publish_1 = require("material-ui-icons/Publish");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const React = require("react");
const react_1 = require("react");
const throttle_debounce_1 = require("throttle-debounce");
require("./edit-orders.less");
let EditOrders = class EditOrders extends react_1.Component {
    constructor() {
        super(...arguments);
        this.filterDate = "";
        this.filterText = "";
        this.order = "ASC";
        this.orderBy = "order.status";
        this.showUpload = false;
        this.showCompleted = false;
        this.showPaidCash = false;
        // For pagination // C-097 claims
        this.page = 1;
        this.limit = 25;
        this.totalPages = 1;
        this.loadOrders = throttle_debounce_1.debounce(200, () => {
            const searchDate = this.filterDate === "" ? "" : new Date(this.filterDate).toDateString();
            const options = {
                count: 100,
                order: this.order,
                search: this.filterText,
                searchDate,
                showCompleted: this.showCompleted.toString(),
                siteId: this.props.site && this.props.site.id,
                sort: this.orderBy,
                start: 0,
                type: this.showPaidCash ? 1 : 0,
                page: this.page,
                limit: this.limit
            };
            store_1.ordersStore.loadOrders(options);
        });
        this.onMouseEnter = () => {
            this.showUpload = true;
        };
        this.onMouseLeave = () => {
            this.showUpload = false;
        };
        // C-097 claim
        this.previousPaginationPage = () => {
            if (store_1.ordersStore.currentPage === 1)
                return;
            this.page = this.page - 1,
                this.limit = this.limit;
            this.loadOrders();
        };
        // C-097 claim
        this.nextPaginationPage = () => {
            if (store_1.ordersStore.currentPage >= store_1.ordersStore.totalProviderPage)
                return;
            this.page = this.page + 1,
                this.limit = this.limit;
            this.loadOrders();
        };
        // C-097 claim
        this.selectPaginationPage = (page) => {
            this.page = this.page,
                this.limit = page,
                this.loadOrders();
        };
        // input functionalty
        this.handleKeyDownInput = (data) => {
            if (data === Number(""))
                return;
            this.page = data;
            this.loadOrders();
        };
        this.onFilterChange = (value, date) => {
            this.filterText = value;
            this.filterDate = date;
            this.loadOrders();
        };
        this.onRequestSort = (property) => {
            if (this.orderBy === property) {
                this.order === "ASC" ? (this.order = "DESC") : (this.order = "ASC");
            }
            else {
                this.orderBy = property;
                this.order = "ASC";
            }
            this.loadOrders();
        };
        this.handleShowCompleted = () => {
            this.showCompleted = !this.showCompleted;
            this.loadOrders();
        };
        this.handleShowPaidCash = () => {
            this.showPaidCash = !this.showPaidCash;
            this.loadOrders();
        };
    }
    async componentDidMount() {
        const searchDate = this.filterDate === "" ? "" : new Date(this.filterDate).toDateString();
        const options = {
            count: 100,
            order: this.order,
            search: this.filterText,
            searchDate,
            showCompleted: this.showCompleted.toString(),
            siteId: this.props.site && this.props.site.id,
            sort: this.orderBy,
            start: 0,
            type: this.showPaidCash ? 1 : 0
        };
        await store_1.ordersStore.loadOrders(options);
    }
    componentWillReceiveProps(nextProps) {
        this.loadOrders();
    }
    render() {
        return (React.createElement("div", { className: "site-edit-orders" }, store_2.usersStore.permissions.ReadClaims ? (React.createElement(React.Fragment, null,
            store_2.usersStore.permissions.CreateClaims && (React.createElement(React.Fragment, null,
                React.createElement("div", { className: "floating-buttons", onMouseEnter: this.onMouseEnter, onMouseLeave: this.onMouseLeave, tabIndex: 0 },
                    React.createElement(button_1.MaterialButton, { fab: true, secondary: true, className: "import-order-btn", to: `/claims/submit/${this.props.site &&
                            this.props.site.id}` },
                        React.createElement(Publish_1.default, null)),
                    React.createElement(button_1.MaterialButton, { fab: true, primary: true, className: "add-order-btn", to: `/claims/new/${this.props.site && this.props.site.id}`, onMouseEnter: this.onMouseEnter },
                        React.createElement(Add_1.default, null))))),
            React.createElement(claims_list_1.ClaimsList, { order: this.order, orderBy: this.orderBy, onRequestSort: this.onRequestSort, onFilterChange: this.onFilterChange, switchLabel2: "Show Cash Paid Claims", filterText: this.filterText, filterDate: this.filterDate, switchChecked: this.showCompleted, switchChecked2: this.showPaidCash, toggleShowCompleted: this.handleShowCompleted, toggleShowPaidCash: this.handleShowPaidCash, clickNext: this.nextPaginationPage, clickPrevious: this.previousPaginationPage, clickSelectDropdown: this.selectPaginationPage, handleKeyDown: this.handleKeyDownInput }))) : (store_2.usersStore.showLock())));
    }
};
__decorate([
    mobx_1.observable
], EditOrders.prototype, "filterDate", void 0);
__decorate([
    mobx_1.observable
], EditOrders.prototype, "filterText", void 0);
__decorate([
    mobx_1.observable
], EditOrders.prototype, "order", void 0);
__decorate([
    mobx_1.observable
], EditOrders.prototype, "orderBy", void 0);
__decorate([
    mobx_1.observable
], EditOrders.prototype, "showUpload", void 0);
__decorate([
    mobx_1.observable
], EditOrders.prototype, "showCompleted", void 0);
__decorate([
    mobx_1.observable
], EditOrders.prototype, "showPaidCash", void 0);
__decorate([
    mobx_1.observable
], EditOrders.prototype, "page", void 0);
__decorate([
    mobx_1.observable
], EditOrders.prototype, "limit", void 0);
__decorate([
    mobx_1.observable
], EditOrders.prototype, "totalPages", void 0);
EditOrders = __decorate([
    mobx_react_1.observer
], EditOrders);
exports.EditOrders = EditOrders;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/sites/modules/sites-detail/components/edit-orders/edit-orders.tsx
// module id = 4040
// module chunks = 0